export default "/_next/static/images/6a5d4f80e6b759cced777eb2f7705e5a.png";